module.exports = __webpack_public_path__ + "static/media/25.21e20dcb.mp3";